// Generated by genversion.
export const version = '2.48.0';
//# sourceMappingURL=version.js.map